export default {
  getFilterForPreTestReserving(state) {
    return state.filterForPreTestReserving;
  },
  getFilterForPreReserving(state) {
    return state.filterForPreReserving;
  },
  replacedSessionData(state) {
    if (!state.replacedSessionData) {
      return JSON.parse(sessionStorage.getItem('replacedSessionData'));
    }
    return state.replacedSessionData;
  },
};
